import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _awaitAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
var makePagedClientRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(CommandCtor, client, input) {
    var _len,
      args,
      _key,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
              args[_key - 3] = _args[_key];
            }
            _context.next = 3;
            return client.send.apply(client, [new CommandCtor(input)].concat(args));
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function makePagedClientRequest(_x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export function createPaginator(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
  return /*#__PURE__*/function () {
    var _paginateOperation = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config, input) {
      var token,
        hasNext,
        page,
        _len2,
        additionalArguments,
        _key2,
        _input$pageSizeTokenN,
        prevToken,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              token = config.startingToken || undefined;
              hasNext = true;
              for (_len2 = _args2.length, additionalArguments = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                additionalArguments[_key2 - 2] = _args2[_key2];
              }
            case 3:
              if (!hasNext) {
                _context2.next = 20;
                break;
              }
              input[inputTokenName] = token;
              if (pageSizeTokenName) {
                input[pageSizeTokenName] = (_input$pageSizeTokenN = input[pageSizeTokenName]) !== null && _input$pageSizeTokenN !== void 0 ? _input$pageSizeTokenN : config.pageSize;
              }
              if (!(config.client instanceof ClientCtor)) {
                _context2.next = 12;
                break;
              }
              _context2.next = 9;
              return _awaitAsyncGenerator(makePagedClientRequest.apply(void 0, [CommandCtor, config.client, input].concat(additionalArguments)));
            case 9:
              page = _context2.sent;
              _context2.next = 13;
              break;
            case 12:
              throw new Error("Invalid client, expected instance of ".concat(ClientCtor.name));
            case 13:
              _context2.next = 15;
              return page;
            case 15:
              prevToken = token;
              token = get(page, outputTokenName);
              hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
              _context2.next = 3;
              break;
            case 20:
              return _context2.abrupt("return", undefined);
            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function paginateOperation(_x, _x2) {
      return _paginateOperation.apply(this, arguments);
    }
    return paginateOperation;
  }();
}
var get = function get(fromObject, path) {
  var cursor = fromObject;
  var pathComponents = path.split(".");
  var _iterator = _createForOfIteratorHelper(pathComponents),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var step = _step.value;
      if (!cursor || typeof cursor !== "object") {
        return undefined;
      }
      cursor = cursor[step];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cursor;
};